import {useCallback, useEffect, useState} from "react";
import {mrbgStore, setChartKey} from './mrbgRedux';
import chartStyle from '../../static/css/MP_charts.module.css'

function MrbgLineChart({chartID,chartInfo,maxHeight,smooth}){

  const
    [chartName,setChartName] = useState( mrbgStore.getState().dynamicChartKey[chartID]?.cName ),
    [pointName,setPointName] = useState( mrbgStore.getState().dynamicChartKey[chartID]?.pName ),
    [pathD,setPathD] = useState({}),
    [shadowD,setShadowD] = useState({}),
    [pointXY,setPointXY] = useState({}),
    createLineChart= useCallback(()=>{
      var sliceNames = [];
      Object.keys(chartInfo).map(cn=>{
        sliceNames = sliceNames.concat( Object.keys(chartInfo[cn].points) )
      })
      sliceNames = [...new Set(sliceNames)]

      const
        LChV = Object.keys(chartInfo).reduce((r, k) => ({ ...r, [k]:[] }), {}),
        pointsArr = Object.keys(chartInfo).reduce((r, k) => ({ ...r, [k]:[] }), []),
        pointsObj = Object.keys(chartInfo).reduce((r, k) => ({ ...r, [k]:sliceNames.reduce((r2,k2)=>({...r2, [k2]:[]}), {}) }), {});

      var
        d = {},
        shadowD = {};

      Object.keys(chartInfo).map(cn=>{
        var
          pointLen = sliceNames.length,
          max = Object.values(chartInfo[cn].points).max(),
          counter = 0,
          cpsX, cpsY, cpeX, cpeY;

        Object.keys(chartInfo[cn].points).map(pn=>{
          var bottom =
            (max == 0)?
              15:
              Math.round(chartInfo[cn].points[pn]*(maxHeight-30)/max*100)/100+15;

          LChV[cn] = {
            x: chartInfo[cn].points[pn],
            y: bottom
          }

          pointsObj[cn][pn] = [counter  *30+15,maxHeight-bottom];
          pointsArr[cn].push( [counter++*30+15,maxHeight-bottom] );
        })

        if( pointsArr[cn].length ){
          d      [cn] = [`M${pointsArr[cn][0]}`];
          shadowD[cn] = [`M${pointsArr[cn][0][0]},${maxHeight-15} V${pointsArr[cn][0][1]}`];

          for( let i=1; i<pointLen; i++ ){
            [cpsX, cpsY] =
              ( i == 1 )?
                controlPointCalc( pointsArr[cn][i-1], null      , pointsArr[cn][i], smooth, false, maxHeight ):
                controlPointCalc( pointsArr[cn][i-1], pointsArr[cn][i-2], pointsArr[cn][i], smooth, false, maxHeight );

            [cpeX, cpeY] =
              ( i == pointsArr[cn].length-1 )?
                controlPointCalc( pointsArr[cn][i], pointsArr[cn][i-1], null         , smooth, true, maxHeight  ):
                controlPointCalc( pointsArr[cn][i], pointsArr[cn][i-1], pointsArr[cn][i+1], smooth, true, maxHeight  );

            d      [cn].push( 'C'+cpsX+','+cpsY+' '+cpeX+','+cpeY+' '+pointsArr[cn][i][0]+','+pointsArr[cn][i][1] )
            shadowD[cn].push( 'C'+cpsX+','+cpsY+' '+cpeX+','+cpeY+' '+pointsArr[cn][i][0]+','+pointsArr[cn][i][1] )
          }

          shadowD[cn].push('V'+(maxHeight-15))

          d[cn]       = d[cn].join(' ');
          shadowD[cn] = shadowD[cn].join(' ');
        }
        else{
          d      [cn] = [];
          shadowD[cn] = [];
        }
      });

      setPathD  ( d )
      setShadowD( shadowD )
      setPointXY( pointsObj )
    },[]);

  useEffect(()=>{
    if( pointName ){
      var
        scrollFrame = document.querySelector(`#${chartID} .${chartStyle.FChScrollFrame}`),
        pointPos= document.querySelector(`.${chartStyle.activePoint}`).getBoundingClientRect().left - scrollFrame.getBoundingClientRect().left + scrollFrame.scrollLeft,
        viewFrameWidth = scrollFrame.offsetWidth;
      scrollFrame.scrollLeft = pointPos-viewFrameWidth/2;
    }
  },[pointName])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setChartName( mrbgStore.getState().dynamicChartKey[chartID]?.cName )
      setPointName( mrbgStore.getState().dynamicChartKey[chartID]?.pName )
    })
    createLineChart()
    return () =>unsubscribe();
  },[])

  if( pathD[chartName] )
    return(
      <>
        <g>
          <path className={chartStyle.LChShadow} d={shadowD[chartName]} />
          <path className={chartStyle.LChPath}   d={pathD  [chartName]} />
        </g>
        <g>
          {
            Object.keys(pointXY[chartName]).map((pn,k)=>{
              return <circle className={pointName==pn? `${chartStyle.LChPoint} ${chartStyle.activePoint}`: chartStyle.LChPoint} cx={pointXY[chartName][pn][0]} cy={pointXY[chartName][pn][1]} key={k} onClick={()=>mrbgStore.dispatch(setChartKey({id:chartID,chartKey:chartName,pointKey:pn}) )}/>
            })
          }
        </g>
      </>
    )
  else
    return( '' )
}
function controlPointCalc( current, previous, next, smooth, reverse, maxHeight ){

  var
    p = (previous)? previous: current,
    n = (next    )? next    : current,
    len,angle,x,y;

  [len, angle] = lineCalc(p, n);

  angle += (reverse)? Math.PI: 0;
  len   *= smooth;

  x = Math.round((current[0]+Math.cos(angle)*len)*100)/100;
  y = Math.min( current[1] + Math.sin(angle) * len, maxHeight );

  return [x, y];
}
function lineCalc( previous, next ){

  var
    lengthX = next[0] - previous[0],
    lengthY = next[1] - previous[1];

  return [
    Math.sqrt(Math.pow(lengthX,2) + Math.pow(lengthY,2)),
    Math.atan2(lengthY,lengthX)
  ];
}
export default MrbgLineChart;